// JadounHub - Language Translations
const translations = {
  en: {
    // Navbar
    marketplace: 'Marketplace',
    aboutUs: 'About Us',
    contactUs: 'Contact Us',
    adminLogin: 'Admin Login',
    joinRegister: 'Join / Register',
    myProfile: 'My Profile',
    myFavorite: 'My Favorite',
    ordersTracking: 'Orders & Tracking',
    helpSupport: 'Help & Support',
    logout: 'Logout Session',

    // Home
    advancedFilters: 'Advanced Filters',
    clearAll: 'Clear All',
    flashSaleOnly: 'Flash Sale Only',
    myWishlist: 'My Wishlist',
    maxPrice: 'Max Price',
    segmentGender: 'Segment / Gender',
    allSegments: 'All Segments',
    maleMen: 'Male / Men',
    femaleWomen: 'Female / Women',
    boysKids: 'Boys (Kids)',
    girlsKids: 'Girls (Kids)',
    filterBySize: 'Filter by Size',
    searchPlaceholder: 'Search products, categories...',
    flashSaleLive: 'Flash Sale Live!',
    endsIn: 'Ends in:',
    viewDeals: '🔥 View Deals',
    showAll: '✕ Show All',
    addToCart: 'Add to Cart',
    buyNow: 'Buy Now',
    noProducts: 'No products found',
    clearSearch: 'Clear search',
    category: 'Category',
    color: 'Color',
    size: 'Size',
    hubVerified: 'Hub Verified',

    // About
    aboutJadounHub: 'About JadounHub',
    indiasTrusted: "India's Trusted",
    marketplace2: 'Marketplace',
    aboutDesc: 'JadounHub is a premium multi-category online marketplace founded with a mission to deliver high-quality products at competitive prices across India.',
    fastDelivery: 'Fast Delivery',
    fastDeliveryDesc: 'Pan-India delivery in 3-5 business days',
    securePayments: 'Secure Payments',
    securePaymentsDesc: 'UPI, COD & encrypted payment gateway',
    qualityProducts: 'Quality Products',
    qualityProductsDesc: 'Verified & quality-checked inventory',

    // Contact
    contactUs2: 'Contact Us',
    getInTouch: 'Get In Touch',
    hereToHelp: "We're here to help! Reach out to us anytime.",

    // Cart
    myBag: 'My Bag',
    bagEmpty: 'Your bag is empty!',
    continueShopping: 'Continue Shopping',
    total: 'Total',
    proceedCheckout: 'Proceed to Checkout',

    // Payment
    cashOnDelivery: 'Cash on Delivery (COD Available)',
    scanQR: 'Scan QR Code to Pay',
    confirmCOD: '📦 Confirm COD Order',
    iHavePaid: "I've Paid",

    // Orders
    ordersPanel: 'Your Orders & Logistics Panel',
    returnToShop: 'Return to Shop',
    orderID: 'Order ID',
    date: 'Date',
    payment: 'Payment',
    totalAmount: 'Total Amount',
    cancelOrder: 'Cancel Order',
    liveTracking: 'Live Tracking Progress',
    estimatedDelivery: 'Estimated Delivery: 3-5 Business Days',
    delivered: '🎉 Package Delivered Successfully!',
    noOrders: 'No orders yet!',
    startShopping: 'Start Shopping',
  },

  hi: {
    // Navbar
    marketplace: 'बाज़ार',
    aboutUs: 'हमारे बारे में',
    contactUs: 'संपर्क करें',
    adminLogin: 'एडमिन लॉगिन',
    joinRegister: 'जुड़ें / रजिस्टर करें',
    myProfile: 'मेरी प्रोफ़ाइल',
    myFavorite: 'मेरे पसंदीदा',
    ordersTracking: 'ऑर्डर और ट्रैकिंग',
    helpSupport: 'सहायता',
    logout: 'लॉगआउट',

    // Home
    advancedFilters: 'उन्नत फ़िल्टर',
    clearAll: 'सब हटाएं',
    flashSaleOnly: 'फ्लैश सेल',
    myWishlist: 'मेरी पसंद',
    maxPrice: 'अधिकतम कीमत',
    segmentGender: 'श्रेणी / लिंग',
    allSegments: 'सभी',
    maleMen: 'पुरुष',
    femaleWomen: 'महिला',
    boysKids: 'लड़के (बच्चे)',
    girlsKids: 'लड़कियां (बच्चे)',
    filterBySize: 'साइज़ से फ़िल्टर करें',
    searchPlaceholder: 'उत्पाद खोजें...',
    flashSaleLive: 'फ्लैश सेल चालू!',
    endsIn: 'समाप्त होने में:',
    viewDeals: '🔥 ऑफर देखें',
    showAll: '✕ सभी दिखाएं',
    addToCart: 'कार्ट में जोड़ें',
    buyNow: 'अभी खरीदें',
    noProducts: 'कोई उत्पाद नहीं मिला',
    clearSearch: 'खोज हटाएं',
    category: 'श्रेणी',
    color: 'रंग',
    size: 'साइज़',
    hubVerified: 'हब वेरिफाइड',

    // About
    aboutJadounHub: 'JadounHub के बारे में',
    indiasTrusted: 'भारत का भरोसेमंद',
    marketplace2: 'बाज़ार',
    aboutDesc: 'JadounHub एक प्रीमियम ऑनलाइन मार्केटप्लेस है जो पूरे भारत में उचित मूल्य पर उच्च-गुणवत्ता वाले उत्पाद पहुंचाने के लिए प्रतिबद्ध है।',
    fastDelivery: 'तेज़ डिलीवरी',
    fastDeliveryDesc: '3-5 कार्यदिवसों में पूरे भारत में डिलीवरी',
    securePayments: 'सुरक्षित भुगतान',
    securePaymentsDesc: 'UPI, COD और एन्क्रिप्टेड पेमेंट गेटवे',
    qualityProducts: 'गुणवत्ता उत्पाद',
    qualityProductsDesc: 'सत्यापित और गुणवत्ता-जांचित इन्वेंटरी',

    // Contact
    contactUs2: 'संपर्क करें',
    getInTouch: 'हमसे जुड़ें',
    hereToHelp: 'हम मदद के लिए यहां हैं! कभी भी संपर्क करें।',

    // Cart
    myBag: 'मेरा बैग',
    bagEmpty: 'आपका बैग खाली है!',
    continueShopping: 'खरीदारी जारी रखें',
    total: 'कुल',
    proceedCheckout: 'चेकआउट करें',

    // Payment
    cashOnDelivery: 'कैश ऑन डिलीवरी (COD उपलब्ध)',
    scanQR: 'QR कोड स्कैन करके भुगतान करें',
    confirmCOD: '📦 COD ऑर्डर कन्फर्म करें',
    iHavePaid: 'मैंने भुगतान कर दिया',

    // Orders
    ordersPanel: 'आपके ऑर्डर और लॉजिस्टिक्स',
    returnToShop: 'वापस जाएं',
    orderID: 'ऑर्डर आईडी',
    date: 'तारीख',
    payment: 'भुगतान',
    totalAmount: 'कुल राशि',
    cancelOrder: 'ऑर्डर रद्द करें',
    liveTracking: 'लाइव ट्रैकिंग',
    estimatedDelivery: 'अनुमानित डिलीवरी: 3-5 कार्यदिवस',
    delivered: '🎉 पैकेज सफलतापूर्वक डिलीवर हुआ!',
    noOrders: 'अभी कोई ऑर्डर नहीं!',
    startShopping: 'खरीदारी शुरू करें',
  }
};
export default translations;